module.exports = __webpack_public_path__ + "static/media/sg3cr84.62129cf5.png";